import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/one/components/platform/v2/pages/CommerceSolutionPageComponent.tsx");
